import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MsgInfoBox, StickyBanner } from './style';
import { CTA, HtmlRaw, Icon, Text } from '../../../atoms';
import { Container } from '../../../gridSystem';
import { TUTOR_ACTIVE_TAB_SET } from '../../../../app/redux/actions/tutors';
import { ModalCancelCourseId } from '../../../atoms/Modals/ModalCancelCourse';
import { MODAL_OPEN } from '../../../../app/redux/actions';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import storage from '../../../../app/api/storage';

const ButtonsBanner = ({
  children,
  mediaIsPhone,
  nextEnabled = false,
  hasMandatoryFields,
  warning,
  onClickConfirm,
  tabs,
  activeTab,
  editMode,
  storeActiveTab,
  modalOpen,
  details,
}) => {
  const bannerRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [showMsg, setShowMsg] = useState(false);
  const [hideMsgModal, setHideMsgModal] = useState(false);

  useLayoutEffect(() => {
    function updateSize() {
      setOffset(bannerRef.current?.offsetLeft);

      setTimeout(() => {
        if (bannerRef.current?.offsetLeft > 0) {
          setOffset(bannerRef.current?.offsetLeft);
        }
      }, 100);
    }
    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  useEffect(() => {
    // last tab checks if is not comlpeted or one of the tabs is disabled
    if (!tabs[activeTab]) {
      setConfirmDisabled(
        tabs?.findIndex((t) => t?.disabled) >= 0 ||
          !tabs[activeTab - 1]?.completed
      );
    } else setConfirmDisabled(tabs[activeTab]?.disabled);
  }, [tabs, activeTab]);

  const handleOnConfirm = () => {
    if (typeof onClickConfirm === 'function') onClickConfirm();
    if (activeTab < tabs?.length) storeActiveTab(activeTab + 1);
  };

  return (
    <>
      <div ref={bannerRef} />
      <StickyBanner offset={offset}>
        {details?.approval_status === 'REJECTED' &&
          !storage?.read('hideRejectMsg')?.value &&
          !hideMsgModal && (
            <MsgInfoBox>
              <Text type="h3" mb={8}>
                Visualizza richiesta di modifica
              </Text>
              <Text type="b4" mb={40}>
                Visualizza il commento riguardante la richiesta di modifica del
                supervisor, con la possibiltà di nascondere o visualizzare la
                finestra cliccando sull’apposito pulsante
              </Text>
              <CTA
                btnText="Ho capito"
                onClick={() => {
                  setHideMsgModal(true);
                  storage?.write('hideRejectMsg', true);
                }}
              />
            </MsgInfoBox>
          )}
        {details?.approval_status === 'REJECTED' && (
          <div className="reject-msg-box">
            <Container className="pt-0">
              <div className="d-flex sb">
                <Text type="h3">
                  Visualizza richiesta di modifica
                  <Icon type="alert-triangle" size={24} clickable={false} />
                </Text>
                <CTA
                  type="tertiary"
                  btnText={showMsg ? 'Riduci' : 'Espandi'}
                  icon={showMsg ? 'chevron-down' : 'chevron-up'}
                  onClick={() => setShowMsg(!showMsg)}
                />
              </div>
              {showMsg && (
                <Text type="b3" mt={16}>
                  <HtmlRaw html={details?.reject_reason} />
                </Text>
              )}
            </Container>
          </div>
        )}
        <div className="btns-banner">
          <Container className="pt-0 d-flex">
            <CTA
              type="secondary"
              btnText="Annulla"
              onClick={() => modalOpen(ModalCancelCourseId)}
              fullsize={mediaIsPhone}
            />
            {!mediaIsPhone && hasMandatoryFields && (
              <Text type="b3" className="legend-mandatory">
                * campo obbligatorio
              </Text>
            )}
            {!mediaIsPhone && warning && (
              <Text type="b4" className="warning d-flex">
                <Icon type="alert-circle" size={16} clickable={false} />
                {warning}
              </Text>
            )}
            {children || (
              <CTA
                disabled={confirmDisabled && !nextEnabled}
                btnText={
                  activeTab === tabs?.length
                    ? editMode
                      ? 'Modifica percorso'
                      : 'Crea Percorso'
                    : 'Prosegui'
                }
                onClick={handleOnConfirm}
                bottomRight={!warning}
                fullsize={mediaIsPhone}
              />
            )}
          </Container>
        </div>
      </StickyBanner>
    </>
  );
};

ButtonsBanner.propTypes = {
  children: PropTypes.node,
  mediaIsPhone: PropTypes.bool,
  nextEnabled: PropTypes.bool,
  hasMandatoryFields: PropTypes.bool,
  warning: PropTypes.string,
  onClickConfirm: PropTypes.func,
  // HOC: state
  tabs: PropTypes.array.isRequired,
  activeTab: PropTypes.number,
  editMode: PropTypes.bool,
  details: PropTypes.object,
  // HOC: dispatch
  storeActiveTab: PropTypes.func,
  modalOpen: PropTypes.func,
};

export default connect(
  (state) => {
    const {
      tabs,
      activeTab,
      course: { editMode },
    } = state.tutors;
    const { details } = state.tutorCourseList;
    return {
      tabs,
      activeTab,
      editMode,
      details,
    };
  },
  (dispatch) => ({
    storeActiveTab: (tab) => dispatch({ type: TUTOR_ACTIVE_TAB_SET, tab }),
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
  })
)(withMediaQueries(ButtonsBanner));
